module.exports = __webpack_public_path__ + "static/media/IconCalendarDay.9234f4da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconCalendarDay.svg
// module id = 936
// module chunks = 0